function canBeMandatory(item) {
    return Object.prototype.hasOwnProperty.call(item, 'isMandatory');
}
export function isMandatory(item) {
    return canBeMandatory(item) && item.isMandatory;
}
export function setIsMandatory(item, isMandatory) {
    if (!canBeMandatory(item)) {
        throw Error('Only IMandatory items can have their isMandatory attribute changed.');
    }
    item.isMandatory = isMandatory;
}
